import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PopwindowComponent } from "./popwindow/popwindow.component";
import { SelectivityComponent } from "./selectivity/selectivity.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { PipeModule } from "../pipe/pipe.module";
import { EditModalComponent } from "./edit-modal/edit-modal.component";
import { KformComponent } from "./kform/kform.component";
import { DrawerComponent } from "./drawer/drawer.component";
import { DropdownButtonComponent } from "./dropdown-button/dropdown-button.component";
import { UploadPictureComponent } from "./upload-picture/upload-picture.component";
import { TableExportTempleteComponent } from "./table-export-templete/table-export-templete.component";
import { ExportTypeComponent } from "./export-type/export-type.component";
import { IndexPageComponent } from "./index-page/index-page.component";
import { NgxEchartsModule } from "ngx-echarts";
import { HttpClientModule } from "@angular/common/http";

@NgModule({
  declarations: [
    PopwindowComponent,
    SelectivityComponent,
    EditModalComponent,
    KformComponent,
    DrawerComponent,
    DropdownButtonComponent,
    UploadPictureComponent,
    TableExportTempleteComponent,
    ExportTypeComponent,
    IndexPageComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    FormsModule,
    PipeModule,
    NgxEchartsModule,
    HttpClientModule,
  ],
  exports: [
    ReactiveFormsModule,
    NgZorroAntdModule,
    FormsModule,
    PipeModule,
    PopwindowComponent,
    KformComponent,
    SelectivityComponent,
    EditModalComponent,
    TableExportTempleteComponent,
    ExportTypeComponent,
    IndexPageComponent,
  ],
  entryComponents: [
    EditModalComponent,
    ExportTypeComponent,
    TableExportTempleteComponent,
  ],
})
export class ComLibraryModule {}
